<div class="retailer-settings">
    <table mat-table [dataSource]="currentRetailer" class="mat-elevation-z0">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.id" | translate }}</th>
            <td mat-cell *matCellDef="let retailer"> {{ retailer.id }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.name" | translate }}</th>
            <td mat-cell *matCellDef="let retailer"> {{ retailer.name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.email" | translate }}</th>
            <td mat-cell *matCellDef="let retailer"> {{ retailer.email }}</td>
        </ng-container>

        <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.location" | translate }}</th>
            <td mat-cell *matCellDef="let retailer"> {{ retailer.location }}</td>
        </ng-container>

        <ng-container matColumnDef="currency">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.currency" | translate }}</th>
            <td mat-cell *matCellDef="let retailer"> {{ retailer.retailerOptions.currencyOptions.currency }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.action" | translate }}</th>
            <td mat-cell *matCellDef="let retailer">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.button.editJson' | translate"
                            (click)="openEditRetailerJsonDialog(retailer)">
                        <mat-icon class="icon">data_object</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.button.editForm' | translate"
                            (click)="openEditRetailerFormDialog(retailer)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.itemStock' | translate"
                            (click)="openUploadItemStockDialog(retailer)">
                        <mat-icon class="icon">edit_note</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.woodStock' | translate"
                            (click)="openUploadWoodStockDialog(retailer)">
                        <mat-icon class="icon">edit_note</mat-icon>
                    </button>
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.rules' | translate"
                            (click)="openEditSafetyEnvironmentsDialog(retailer)">
                        <mat-icon class="icon">terminal</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="assets">
            <th mat-header-cell *matHeaderCellDef>{{ "retailerList.column.assets" | translate }}</th>
            <td mat-cell *matCellDef="let retailer">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.uploadAssetFavicon' | translate"
                            (click)="fileInputFavicon.click()"
                            [disabled]="inProgress">
                        <input #fileInputFavicon type="file" accept="image/*" class="file-upload" hidden
                               (change)="uploadAsset($event, 'favicon', retailer, fileInputFavicon)">
                        <mat-icon class="icon">upload_file</mat-icon>
                    </button>
                    @if (retailer.retailerOptions?.favicon) {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'retailerList.tooltips.viewAssetFavicon' | translate"
                                (click)="openAsset(retailer.retailerOptions.favicon)">
                            <mat-icon class="icon">image</mat-icon>
                        </button>
                    }

                    <button mat-button
                            class="table-button"
                            [matTooltip]="'retailerList.tooltips.uploadAssetBanner' | translate"
                            (click)="fileInputBanner.click()"
                            [disabled]="inProgress">
                        <input #fileInputBanner type="file" accept="image/*" class="file-upload" hidden
                               (change)="uploadAsset($event, 'banner', retailer, fileInputBanner)">
                        <mat-icon class="icon">upload_file</mat-icon>
                    </button>
                    @if (retailer.retailerOptions?.banner) {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'retailerList.tooltips.viewAssetBanner' | translate"
                                (click)="openAsset(retailer.retailerOptions.banner)">
                            <mat-icon class="icon">image</mat-icon>
                        </button>
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <h2 class="font-h2">{{ 'font.title' | translate }}</h2>
    <h3 class="font-h3">{{ 'font.warning' | translate }}</h3>
    <div>
        <div class="asset-upload">
            <p>{{ 'font.regular' | translate }}</p>
            <app-button class="upload-button"
                        [label]="'font.tooltips.regular-asset' | translate"
                        [disabled]="inProgress"
                        (click)="fileInputFontRegular.click()">
                <input #fileInputFontRegular hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'font', currentRetailer[0], fileInputFontRegular, undefined, 'regular')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.font?.regularFontAsset) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions?.font.regularFontAsset.filename }}</p>
            }
        </div>
        <div class="asset-upload">
            <p><strong>{{ 'font.bold' | translate }}</strong></p>
            <app-button class="upload-button"
                        [label]="'font.tooltips.bold-asset' | translate"
                        [disabled]="inProgress"
                        (click)="fileInputFontBold.click()">
                <input #fileInputFontBold hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'font', currentRetailer[0], fileInputFontBold, undefined, 'bold')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.font?.boldFontAsset) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.font.boldFontAsset.filename }}</p>
            }
        </div>
        <div class="asset-upload">
            <p><em>{{ 'font.italic' | translate }}</em></p>
            <app-button class="upload-button"
                        [label]="'font.tooltips.italic-asset' | translate"
                        [disabled]="inProgress"
                        (click)="fileInputFontItalic.click()">
                <input #fileInputFontItalic hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'font', currentRetailer[0], fileInputFontItalic, undefined, 'italic')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.font?.italicFontAsset) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.font.italicFontAsset.filename }}</p>
            }
        </div>
        <div class="asset-upload">
            <p>{{ 'font.medium' | translate }}</p>
            <app-button
                class="upload-button"
                [label]="'font.tooltips.medium-asset' | translate"
                [disabled]="inProgress"
                (click)="fileInputFontMedium.click()">
                <input #fileInputFontMedium hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'font', currentRetailer[0], fileInputFontMedium, undefined, 'medium')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.font?.mediumFontAsset) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.font.mediumFontAsset.filename }}</p>
            }
        </div>
    </div>
    <br>
    <h2 class="font-h2">{{ 'font.price.title' | translate }}</h2>
    <h3 class="font-h3">{{ 'font.price.description' | translate }}</h3>
    <div class="asset-upload">
        <p>{{ 'font.price.title' | translate }}</p>
        <app-button
            class="upload-button"
            [label]="'font.price.tooltip' | translate"
            [disabled]="inProgress"
            (click)="fileInputPriceFont.click()">
            <input #fileInputPriceFont hidden
                   type="file"
                   class="file-upload"
                   (change)="uploadAsset($event, 'font', currentRetailer[0], fileInputPriceFont, undefined, 'price')">
        </app-button>
        @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.priceAppearance?.font) {
            <mat-icon class="icon checkmark">check</mat-icon>
            <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.priceAppearance.font.filename }}</p>
        }
    </div>
    <br>
    <h2 class="font-h2">{{ 'icon.title' | translate }}</h2>
    <h3 class="font-h3">{{ 'icon.warning' | translate }}</h3>
    <h3 class="font-h3">{{ 'icon.warning2' | translate }}</h3>
    <h3 class="font-h3">{{ 'icon.warning3' | translate }}</h3>
    <div>
        <div class="asset-upload">
            <p>{{ 'icon.measurement' | translate }}</p>
            <app-button class="upload-button"
                        [label]="'icon.tooltips.measurement' | translate"
                        [disabled]="inProgress"
                        (click)="fileInputIconMeasurement.click()">
                <input #fileInputIconMeasurement hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'icon', currentRetailer[0], fileInputIconMeasurement, undefined, undefined, 'measurement')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.configuratorIcons?.measurement) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.configuratorIcons.measurement.filename }}</p>
            }
        </div>
        <div class="asset-upload">
            <p>{{ 'icon.wood-type' | translate }}</p>
            <app-button class="upload-button"
                        [label]="'icon.tooltips.wood-type' | translate"
                        [disabled]="inProgress"
                        (click)="fileInputIconWoodType.click()">
                <input #fileInputIconWoodType hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'icon', currentRetailer[0], fileInputIconWoodType, undefined, undefined, 'woodType')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.configuratorIcons?.woodType) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.configuratorIcons.woodType.filename }}</p>
            }
        </div>
        <div class="asset-upload">
            <p>{{ 'icon.reset' | translate }}</p>
            <app-button class="upload-button"
                        [label]="'icon.tooltips.reset' | translate"
                        [disabled]="inProgress"
                        (click)="fileInputIconReset.click()">
                <input #fileInputIconReset hidden
                       type="file"
                       class="file-upload"
                       (change)="uploadAsset($event, 'icon', currentRetailer[0], fileInputIconReset, undefined, undefined, 'reset')">
            </app-button>
            @if (currentRetailer?.length > 0 && currentRetailer[0]?.retailerOptions?.configuratorOptions?.configuratorIcons?.reset) {
                <mat-icon class="icon checkmark">check</mat-icon>
                <p>{{ currentRetailer[0].retailerOptions.configuratorOptions.configuratorIcons.reset.filename }}</p>
            }
        </div>
    </div>

    @if (currentRetailer?.length > 0 && currentRetailer[0].retailerOptions?.helpItems?.length > 0) {
        <h2 class="font-h2">{{ "retailerList.helpItems.title" | translate }}</h2>
        @for (item of currentRetailer[0].retailerOptions.helpItems; track item) {
            <div>
                <h3 class="font-h3">
                    {{ 'retailerList.helpItems.subtitle' | translate }}: {{ item.title }} ({{ item.order }})
                </h3>
                <div class="button-container">
                    <p>{{ 'retailerList.helpItems.videoAsset.title' | translate }}</p>
                    @if (item.videoAsset) {
                        <app-button [fillParent]="false" (click)="openAsset(item.videoAsset)"
                                    [label]="'retailerList.helpItems.videoAsset.show' | translate"
                                    [disabled]="inProgress">
                        </app-button>
                    }
                    <app-button (click)="fileInputVideo.click()"
                                [label]="'retailerList.helpItems.videoAsset.upload' | translate"
                                [disabled]="inProgress">
                        <input #fileInputVideo type="file" accept="video/mp4" class="file-upload" hidden
                               (change)="uploadAsset($event, 'helpItemVideo', currentRetailer[0], fileInputVideo, item.order)">
                    </app-button>
                </div>
                <div class="button-container">
                    <p>{{ 'retailerList.helpItems.thumbnailAsset.title' | translate }}</p>
                    @if (item.thumbnailAsset) {
                        <app-button (click)="openAsset(item.thumbnailAsset)"
                                    [label]="'retailerList.helpItems.thumbnailAsset.show' | translate"
                                    [disabled]="inProgress">
                        </app-button>
                    }
                    <app-button (click)="fileInputThumbnail.click()"
                                [label]="'retailerList.helpItems.thumbnailAsset.upload' | translate"
                                [disabled]="inProgress">
                        <input #fileInputThumbnail type="file" accept="image/*" class="file-upload" hidden
                               (change)="uploadAsset($event, 'helpItemThumbnail', currentRetailer[0], fileInputThumbnail, item.order)">
                    </app-button>
                </div>
            </div>
        }
    }
</div>

